import React from 'react';

interface GradientTextProps {
  children: React.ReactNode;
  variant?: 'primary' | 'hero' | 'accent' | 'purple' | 'custom';
  className?: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  gradient?: string;
}

const GradientText: React.FC<GradientTextProps> = ({
  children,
  variant = 'primary',
  className = '',
  as: Component = 'span',
  gradient,
}) => {
  const gradientClasses = {
    primary: 'bg-gradient-to-r from-primary to-secondary',
    hero: 'bg-gradient-to-r from-primary via-secondary to-accent',
    accent: 'bg-gradient-to-r from-secondary to-accent',
    purple: 'bg-gradient-to-r from-kexa-purple to-kexa-navy',
    custom: gradient || 'bg-gradient-to-r from-primary to-secondary',
  };

  const baseClasses = `
    bg-clip-text text-transparent font-bold
    animate-fade-in
  `;

  const combinedClasses = `
    ${baseClasses}
    ${gradientClasses[variant]}
    ${className}
  `;

  return (
    <Component className={combinedClasses}>
      {children}
    </Component>
  );
};

export default GradientText;